import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import TopBar from "../../../components/TopBarComponent/Topbar";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import TableContent from "../../../constants/dummyData.json";
import "./vehicleDetails.css";
import { VehicleDetailsContext } from "../VehicleDetailsView";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
const Content = TableContent.vehicleDetails;

const tableHeader = [
  { title: "Visitor Name", prop: "VisitorName" },
  { title: "Visitor Type", prop: "VisitorType" },
  { title: "Contact No", prop: "VisitorPhoneNo" },
  { title: "Vehicle No", prop: "VehicleNo" },
  { title: "In/Out", prop: "in_out" },
  { title: "Date", prop: "date" },
  { title: "Time", prop: "time" },
  { title: "No Of People", prop: "count" },
];

const VehicleDetails = ({ textContent }) => {
  const {
    goBack,
    vehicleData,
    fromDate,
    toDate,
    onPageChange,
    currentPageData,
    zoneNewExcel,
    pageCount,
    excelReport,
    logout,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    downloadExcelSpinnerStatus,
    spinnerStatus
  } = useContext(VehicleDetailsContext);

  return (
    <div className="vehicle-detail">
        {spinnerStatus && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="title-name">{textContent.title}</p>
          </div>
          <div className="text-align">
            <span>
              <label className="from-date-label">
                {textContent.fromDateLabel}
              </label>
              <span className="date">{fromDate}</span>
            </span>
            <span>
              <label className="to-date-label">{textContent.toDateLabel}</label>
              <span className="date border-line">{toDate}</span>
            </span>
            <span className="download-text">
              <a
                className={zoneNewExcel ? "excel-download" : "disabled-button"}
                href={zoneNewExcel && `${baseURL}/excel/${zoneNewExcel}`}
              >
                <img className="excel-icon" src={ExcelIcon} alt="Excel-icon" />
                {downloadExcelSpinnerStatus ? (
                  <Spinner size="sm" />
                ) : (
                  textContent.downLoadText
                )}
              </a>
            </span>
          </div>
        </div>
        <DataTable
          tableData={vehicleData}
          header={tableHeader}
          isPagination={true}
          onPageChange={(e) => onPageChange(e)}
          currentPage={currentPageData}
          pageCount={pageCount}
        />
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default VehicleDetails;
